<template>
    <div class="modal" ref="usePatternModal" id="usePatternModal" role="dialog">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">

                <div class="modal-header bg-teal text-white font-bold">
                    Use Search Pattern
                </div>

                <div class="modal-body bg-white">
                    <multiselect :options="patterns"
                        v-model="selectedPattern"
                        placeholder="Select the search pattern..."
                        :show-labels="false"
                        track-by="id" label="name" class="mb-2 cursor-pointer">
                    </multiselect>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-primary" @click.prevent="search()">
                        Search
                    </button>
                    <button class="btn btn-link" type="reset" data-dismiss="modal">
                        Close
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import Form from "../../../utils/form";
import Multiselect from 'vue-multiselect';

export default {
    name: 'use-pattern',
    components: { Multiselect },

    data() {
        return {
            patterns: [],
            selectedPattern: {}
        }
    },

    mounted() {
        $("#usePatternModal").on('hidden.bs.modal', () => this.clear());
    },

    methods: {
        open() {
            $(this.$el).modal('show');
            axios.get('/api/search-patterns')
                .then( ({ data }) => {
                    this.patterns = data;
                })
                .catch( err => {
                    console.error(err);
                });
        },

        close() {
            $(this.$el).modal('hide');
            this.clear();
        },

        clear() {
            this.patterns        = [];
            this.selectedPattern = {}
        },

        search()
        {
            this.$emit('use-pattern', JSON.parse(this.selectedPattern.pattern));
            this.close();
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

